<div class="iconType">


    <mat-icon role="img" class="" aria-hidden="true" data-mat-icon-type="svg" data-mat-icon-name="document" data-mat-icon-namespace="heroicons_solid">
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="80" viewBox="0 0 30 30" fill="none"  >
        <path  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" ></path>
    </svg></mat-icon>
    
    <!-- <mat-icon>insert_drive_file</mat-icon> -->

    <ng-container *ngIf="iconType == 'PDF'">
        <span class="icon pdf">{{iconType}}</span>
    </ng-container>
    
    <ng-container *ngIf="iconType == 'MULTI'">
        <span class="icon multiPdf">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'EXCEL'">
        <span class="icon excel">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'FORM'">
        <span class="icon form">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'HTML'">
        <span class="icon html">{{iconType}}</span>
    </ng-container>



    <ng-container *ngIf="iconType == 'HEIC' || iconType == 'JPG' || iconType == 'PNG' || iconType == 'PPT'" >
        <span class="icon jpg">{{iconType}}</span>
    </ng-container>
    
    <ng-container *ngIf="iconType == 'WORD'">
        <span class="icon word">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'EXCEL'">
        <span class="icon excel">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'TEXT'">
        <span class="icon text">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'TABULAR'">
        <span class="icon tabular">{{iconType}}</span>
    </ng-container>

    <ng-container *ngIf="iconType == 'OTHER'">
        <span class="icon">{{iconType}}</span>
    </ng-container>
    
    
</div>